import { useQuery } from '@apollo/client';
import {
  useRecoilState, useRecoilValue, useSetRecoilState,
} from 'recoil';
import { useConditionalEffect, usePrevious } from 'react-delta';

import * as K from 'common/constants';
import { UrlParams } from 'common/types';
import { SETTINGS_QUERY } from 'common/queries/apolloQueries';
import { applyParamsToSettings, getDisplaySettingsFromParams, processServerSettings } from 'common/util/settings';

import { locationState } from 'components/common/Managers/RouteStateManager.state';
import { CustomLocationState } from 'components/common/Managers/RouteStateManager.utils';

import { savedSettingsState, settingsProcessedState, settingsState } from './SettingsManager.state';

/**
 * Settings state management component. This component never renders content.
 */
function SettingsManager(): JSX.Element {

  const { data } = useQuery(SETTINGS_QUERY);
  const [ settings, setSettings ] = useRecoilState(settingsState);
  const setSettingsProcessed = useSetRecoilState(settingsProcessedState);
  const setSavedSettings = useSetRecoilState(savedSettingsState);
  // const searchParams = useRecoilValue(searchParamRecordState);

  const prevSettingsData = usePrevious(data);

  const historyLocation = useRecoilValue(locationState);
  const historyLocationState = historyLocation.state as CustomLocationState;

  // run this effect only on the render settingsData is first populated
  useConditionalEffect(() => {
    // fold in settings from the URL
    const settingsParams = getDisplaySettingsFromParams(historyLocationState?.disposableParams || {} as UrlParams);
    const newSettings = applyParamsToSettings(processServerSettings(settings, { ...data.systemSettings, ...data.displaySettings }), settingsParams);
    setSettings(newSettings);
    setSettingsProcessed(true);
    setSavedSettings(processServerSettings(K.DEFAULT_SETTINGS, { ...data.systemSettings, ...data.displaySettings }));
  }, !!data && !prevSettingsData);

  return <></>;
}

export default SettingsManager;
